/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if(boostSDAppConfig?.searchSettings) {
  boostSDAppConfig.searchSettings.suggestionMobileStyle = 'style2';
}